/**
 * useForge Hook
 *
 * Convenience hook to access FORGE context
 * Provides easy access to FORGE state and actions
 */

import { useContext } from 'react';
import { ForgeContext } from '../ForgeProvider';
import type { ForgeContextValue } from '../types/forge';

/**
 * Hook to access FORGE context
 * Must be used within ForgeProvider
 */
export const useForge = (): ForgeContextValue => {
  const context = useContext(ForgeContext);

  if (context === undefined) {
    throw new Error('useForge must be used within a ForgeProvider');
  }

  return context;
};

export default useForge;
